<template>
  <a href="/"><img src="/assets/icon/icon.png" style="width:32px;vertical-align: bottom"/></a>
</template>
